export enum UserElementalRole {
  ALL = 'ALL',
  USR_PRV_PREVIEW = 'USR_PRV_PREVIEW',
  ACC_UPDATE = 'ACC_UPDATE',
  ACC_PREVIEW = 'ACC_PREVIEW',
  PRO_PB_PREVIEW = 'PRO_PB_PREVIEW',
  PRO_PB_CREATE = 'PRO_PB_CREATE',
  PRO_ABPB_PREVIEW = 'PRO_ABPB_PREVIEW',
  PRO_ABPB_CREATE = 'PRO_ABPB_CREATE',
  ACC_ADM_PREVIEW = 'ACC_ADM_PREVIEW',
  GEN_DASHBOARD = 'GEN_DASHBOARD',
  REG_CODE_GENERATE = 'REG_CODE_GENERATE',
  PB_PREVIEW = 'PB_PREVIEW',
  ABPB_INVITATION = 'ABPB_INVITATION',
  ACC_ADM_UPDATE = 'ACC_ADM_UPDATE',
  USR_PRV_UPDATE = 'USR_PRV_UPDATE',
}
